import { Component } from '@angular/core';
import { Router }            from '@angular/router';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';


import { DoctorService }  from '../../services/doctors/doctor.service';

import { UserSearchComponent } from '../../users/search/user-search.component';

@Component({
  moduleId: module.id,
  selector: 'doctor-search',
  templateUrl: './doctor-search.component.html',
  styleUrls: [ '../../users/search/user-search.component.css' ]
})

export class DoctorSearchComponent extends UserSearchComponent {

  users: Observable<any[]>;

  constructor(
    protected router: Router,
    protected doctorService: DoctorService) { super(router, doctorService); }


  gotoDetail(user: any): void {
    
    this.router.navigate([ this.getDetailUrl() + user.id ]);
  }

  protected getDetailUrl(): string {

    return '/doctor/';
  };

  protected getUserString(): string {

    return 'Doctor';
  };

}



// WEBPACK FOOTER //
// ./src/app/doctors/search/doctor-search.component.ts